import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

// project imports
import useAuth from 'hooks/useAuth';
import Loader from 'ui-component/Loader';
import { DASHBOARD_PATH } from 'config';
import { GuardProps } from 'types';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
  
    const params = new URLSearchParams(location.search);
    const sid = params.get("sid");
   
    if (isInitialized && isLoggedIn && pathname == "/signin") {
      
      if (sid) navigate(`/connect/store?sid=${sid}`);
      else navigate(DASHBOARD_PATH, { replace: true });;
    }
    
  }, [isLoggedIn, isInitialized, navigate]);

  if (!isInitialized) {
    return <Loader />;
  }

  if (isLoggedIn) {
    return <Loader />;
  }

  return children;
}
